module.exports = __webpack_public_path__ + "img/Path_right.8242c864.svg";